import React from "react";
import { useSelector } from "react-redux";
import "../../../styles/pt/three-day-trial-stats.css";
import CalendarLoader from "../../common-components/CalendarLoader";
import { PTIcon } from "../../../images/icons/icons";

const ThreeDayTrialStats = () => {
  const { threeDayPTMembersStats, threeDayPTMembersStatsLoading } = useSelector(
    (state) => state.plans
  );

  const statsData = threeDayPTMembersStats?.data || {};

  // const statsCards = [
  //   {
  //     label: "Total Members",
  //     value: statsData?.total_members || 0,
  //     bgColor: "#E3F2FD",
  //     textColor: "#1565C0",
  //     icon: "👥",
  //   },
  //   {
  //     label: "Assigned",
  //     value: statsData?.total_assigned || 0,
  //     bgColor: "#E8F5E9",
  //     textColor: "#2E7D32",
  //     icon: "✅",
  //   },
  //   {
  //     label: "Not Assigned",
  //     value: statsData?.total_not_assigned || 0,
  //     bgColor: "#FFEBEE",
  //     textColor: "#C62828",
  //     icon: "❌",
  //   },
  //   {
  //     label: "Day 1",
  //     value: statsData?.day_1 || 0,
  //     bgColor: "#F3E5F5",
  //     textColor: "#6A1B9A",
  //     icon: "1️⃣",
  //   },
  //   {
  //     label: "Day 2",
  //     value: statsData?.day_2 || 0,
  //     bgColor: "#FFF3E0",
  //     textColor: "#E65100",
  //     icon: "2️⃣",
  //   },
  //   {
  //     label: "Day 3",
  //     value: statsData?.day_3 || 0,
  //     bgColor: "#E0F2F1",
  //     textColor: "#00695C",
  //     icon: "3️⃣",
  //   },
  //   {
  //     label: "Completed",
  //     value: statsData?.completed || 0,
  //     bgColor: "#E1F5FE",
  //     textColor: "#01579B",
  //     icon: "🎯",
  //   },
  // ];

  return (
    <>
      {/* <div className="three-day-stats-wrapper">
        <div className="three-day-stats-grid">
          {statsCards.map((card, index) => (
            <div
              key={index}
              className="three-day-stat-card"
              style={{
                backgroundColor: card.bgColor,
                borderLeft: `4px solid ${card.textColor}`,
              }}
            >
              <div className="stat-card-icon">{card.icon}</div>
              <div className="stat-card-content">
                <div
                  className="stat-card-value"
                  style={{ color: card.textColor }}
                >
                  {card.value.toLocaleString()}
                </div>
                <div className="stat-card-label">{card.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div> */}

      <div className={`live-subscriptions mr-kpi-grid grid-4 mt30`}>
        {threeDayPTMembersStatsLoading ? (
          <CalendarLoader daysCount={7} shiftsPerDay={2} />
        ) : (
          statsData &&
          Object.entries(statsData)?.map(([key, data]) => {
            return (
              <div className="mr-kpi-card" key={key}>
                <div className="mr-kpi-head">
                  <div>
                    <p className="mr-kpi-title">{key?.replace(/_/g, " ")}</p>
                    <div className="mr-kpi-value-row">
                      <div className="mr-kpi-value"> {data || 0}</div>
                    </div>
                  </div>
                  <span
                    className="mr-kpi-card-icon-container"
                    style={{
                      backgroundColor:
                        key === "total_assigned"
                          ? "#dbeafe"
                          : key === "completed"
                          ? "#d1fae5"
                          : key === "day_1"
                          ? "#fed7aa"
                          : key === "total_not_assigned"
                          ? "#fee2e2"
                          : "#f3f4f6",
                      color:
                        key === "total_assigned"
                          ? "#1e40af"
                          : key === "completed"
                          ? "#065f46"
                          : key === "day_1"
                          ? "#c2410c"
                          : key === "total_not_assigned"
                          ? "#dc2626"
                          : "#374151",
                    }}
                  >
                    <PTIcon />
                  </span>
                </div>
              </div>
            );
          })
        )}
      </div>
    </>
  );
};

export default ThreeDayTrialStats;
